import { buildBinderListings } from '@monofe/di';
import authApiBinder from '../impl/auth.bind';
import mediaDiffApiBinder from '../impl/mediaDiff.bind';
import mediaApiBinder from '../impl/mediaVTS.bind';
import siteDataApiBinder from '../impl/siteData.bind';

export default buildBinderListings([
    authApiBinder,
    mediaDiffApiBinder,
    mediaApiBinder,
    siteDataApiBinder,
]);
